import { inject, ComponentEventBus, prop } from "fw";

@inject
export class ModalWithHeader {
    @prop(null) dataId: string | null;
    @prop(null) width: number | null;
    @prop(840) maxWidth: number;

    constructor(private ceb: ComponentEventBus) {}

    close() {
        this.ceb.dispatch("close");
    }
}
